import { atom } from "jotai";
export const visibleModalDomicilioAtom = atom(false);
export const visibleModalDatosNacimientoAtom = atom(false);
export const visibleModalContactoEmergenciaAtom = atom(false);
export const visibleModalRegimenPensionarioAtom = atom(false);